import { create } from 'zustand';
import type { StoreType } from '@/types/store';
import { createStudySlice } from './studySlice';
import { createCalcSlice } from './calcSlice';
import { createUiSlice } from './uiSlice';
import { createSettingsSlice } from './settingsSlice';
import { createDatasetSlice } from './datasetSlice';
import { createAuditSlice } from './auditSlice';
import { createRecomputeMiddleware } from './middleware/recompute';
import { createPersistMiddleware } from './middleware/persist';
import { DEFAULT_SETTINGS } from '@/types/persistence';

export const useStore = create<StoreType>()(
  createPersistMiddleware(
    createRecomputeMiddleware((...a) => ({
      ...createStudySlice(...a),
      ...createCalcSlice(...a),
      ...createUiSlice(...a),
      ...createSettingsSlice(...a),
      ...createDatasetSlice(...a),
      ...createAuditSlice(...a),
      settings: { ...DEFAULT_SETTINGS },
      trail: [],
      dataset: null,
      warnings: [],
    })),
  ),
);
